/**
 * Verbessert die Barrierefreiheit für das Elementor Nested Accordion Widget.
 * Verschiebt den Fokus nach dem Öffnen per Tastatur in den Inhaltsbereich.
 */
function initAccordeonOptimization() {
    // --- Übersetzungen ---
    const i18nGlobal = (typeof WCO_UI_Translations !== 'undefined') ? WCO_UI_Translations : {};
    const i18nAcc = i18nGlobal.accordion || {};
    const elementorDefaultLabel = 'Accordion. Open links with Enter or Space, close with Escape, and navigate with Arrow Keys';
    const translatedLabel = i18nAcc.label || elementorDefaultLabel;

    const accordions = document.querySelectorAll('.e-n-accordion');

    if (!accordions.length) {
        return;
    }

    accordions.forEach(accordion => {
        if (accordion.getAttribute('aria-label') === elementorDefaultLabel) {
            accordion.setAttribute('aria-label', translatedLabel);
        }

        const items = accordion.querySelectorAll('.e-n-accordion-item');

        if (!items.length) {
            return;
        }

        items.forEach(item => {
            const trigger = item.querySelector('.e-n-accordion-item-title');
            const contentPanel = item.querySelector('.e-n-accordion-item > .e-con');

            if (!trigger || !contentPanel) {
                return;
            }

            trigger.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter') {
                    return;
                }

                setTimeout(() => {
                    const isExpanded = item.hasAttribute('open');

                    if (isExpanded) {
                        contentPanel.setAttribute('tabindex', '-1');
                        contentPanel.focus();
                    }
                }, 100);
            });

            contentPanel.addEventListener('blur', () => {
                contentPanel.removeAttribute('tabindex');
            });
        });

        accordion.setAttribute('role', 'region');
    });
}

export { initAccordeonOptimization };